import { render, staticRenderFns } from "./peoples.vue?vue&type=template&id=039957af&"
import script from "./peoples.vue?vue&type=script&lang=js&"
export * from "./peoples.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports